import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { expensesAPI } from '../../services/api';
import toast from 'react-hot-toast';
import PrintLetterhead from '../common/PrintLetterhead';

export default function ExpenseForm() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    expense_date: new Date().toISOString().split('T')[0],
    amount: '',
    tax_amount: '',
    description: '',
    payment_method: 'Cash',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => { expensesAPI.categories().then(setCategories); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await expensesAPI.create(form);
      toast.success('Expense recorded');
      navigate('/expenses');
    } catch (err) { toast.error(err.message); }
    setLoading(false);
  };

  const u = (f) => (e) => setForm({ ...form, [f]: e.target.value });

  return (
    <div>
      <div className="toolbar">
        <h2>New Expense</h2>
        <div className="toolbar-right">
          <button type="button" className="btn btn-outline" onClick={() => navigate('/expenses')}>Cancel</button>
          <button type="submit" className="btn btn-primary" form="expense-form" disabled={loading}>
            {loading ? 'Saving...' : 'Record Expense'}
          </button>
        </div>
      </div>

      <div className="df-editor">
        <div className="df-section-header">
          <span>Expense Details</span>
        </div>
        <form id="expense-form" onSubmit={handleSubmit}>
          <div className="df-body">
            <PrintLetterhead />
            <div className="df-grid cols-2">
              <div className="df-field">
                <label>Date <span className="req">*</span></label>
                <input type="date" required value={form.expense_date} onChange={u('expense_date')} />
              </div>
              <div className="df-field">
                <label>Category</label>
                <select value={form.expense_category_id || ''} onChange={e => setForm({ ...form, expense_category_id: parseInt(e.target.value) || null })}>
                  <option value="">Select...</option>
                  {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div className="df-field">
                <label>Amount <span className="req">*</span></label>
                <input type="number" step="0.01" required value={form.amount || ''} onChange={u('amount')} placeholder="0.00" />
              </div>
              <div className="df-field">
                <label>Tax Amount</label>
                <input type="number" step="0.01" value={form.tax_amount || ''} onChange={u('tax_amount')} placeholder="0.00" />
              </div>
              <div className="df-field">
                <label>Payment Method</label>
                <select value={form.payment_method} onChange={u('payment_method')}>
                  <option value="Cash">Cash</option>
                  <option value="Check">Check</option>
                  <option value="CreditCard">Credit Card</option>
                  <option value="BankTransfer">Bank Transfer</option>
                  <option value="PettyCash">Petty Cash</option>
                </select>
              </div>
              <div className="df-field">
                <label>Reference</label>
                <input value={form.reference || ''} onChange={u('reference')} placeholder="Optional" />
              </div>
              <div className="df-field full">
                <label>Description</label>
                <textarea value={form.description || ''} onChange={u('description')} placeholder="Expense description" />
              </div>
            </div>
          </div>
          <div className="df-actions">
            <button type="button" className="btn btn-outline" onClick={() => navigate('/expenses')}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? 'Saving...' : 'Record Expense'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
